<template>
  <el-select clearable @change="handleChange" :value="data" placeholder="请选择">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in list" :key="index"></el-option>
  </el-select>
</template>

<script>
  export default {
    name: "CustomerType",
    watch: {
      value: {
        immediate: true,
        handler: function(value) {
          this.data = value;
        }

      }
    },
    props: ["value"],
    data() {
      return {
        data: "",
        list: [{
            name: "普票",
            value: 1
          },
          {
            name: "专票",
            value: 2
          }
        ]
      }
    },
    methods: {
      handleChange(value) {
        this.data = value;
        this.$emit("input", value)
      }
    }
  }
</script>

<style scoped>

</style>
